import { render } from "./Jobs.vue?vue&type=template&id=70ed7264&scoped=true"
import script from "./Jobs.vue?vue&type=script&lang=js"
export * from "./Jobs.vue?vue&type=script&lang=js"

import "./Jobs.vue?vue&type=style&index=0&id=70ed7264&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ed7264"]])

export default __exports__